export const LOG_IN = "LOG_IN"
export const ATUALIZAR_SACOLA = "ATUALIZAR_SACOLA"
export const INCLUIR_ITEM_SACOLA = "INCLUIR_ITEM_SACOLA"
export const EXCLUIR_ITEM_SACOLA = "REMOVER_ITEM_SACOLA"
export const LIMPAR_SACOLA = "LIMPAR_SACOLA"
export const ATUALIZAR_GRUPOS = "ATUALIZAR_GRUPOS"
export const ATUALIZAR_MENU = "ATUALIZAR_MENU"
export const OCULTAR_MENU = "OCULTAR_MENU"